const slots = [{
  id: 'div-gpt-ad-category-dmpu-0-0',
  sizes: [[300, 600]],
  targeting: {
    index: 6008,
    hivis: 'n',
  },
}]
export default slots;
